import React, { useEffect, useMemo, useState } from "react";
import {
  getCurrentTimeZone,
  getDateString,
  getTimeDifferenceString,
} from "../../../utils/dateutils";
import apiService from "../../../service/apiservice/apiService";
import { Col, Spin } from "antd";
import SectionCard from "../../generic/sectioncard/SectionCard";
import VolunteerStatistics from "./VolunteerStatistics";
import {
  mileageFields,
  statisticsFields,
} from "../../../components/generic/profiledataextractor/utils";

const currentYear = new Date(new Date().getFullYear(), 0, 1).getTime();

const VolunteerStatisticsWrapper = ({ workforceIdentifier }) => {
  const [volunteerStatistics, setVolunteerStatistics] = useState({});
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [loading, setLoading] = useState(false);

  const statistics = useMemo(() => {
    return {
      yearsOfService: volunteerStatistics?.joiningDate
        ? getTimeDifferenceString(volunteerStatistics?.joiningDate)
        : "--",
      totalHours:
        volunteerStatistics?.totalDirectHours +
          volunteerStatistics?.totalIndirectHours || 0,
      yearlyHours:
        volunteerStatistics?.yearlyDirectHours +
          volunteerStatistics?.yearlyIndirectHours || 0,
      monthlyHours:
        volunteerStatistics?.monthlyDirectHours +
          volunteerStatistics?.monthlyIndirectHours || 0,
      quarterlyHours:
        volunteerStatistics?.quarterlyDirectHours +
          volunteerStatistics?.quarterlyIndirectHours || 0,
      totalMileage:
        volunteerStatistics?.totalDirectMileage +
        volunteerStatistics?.totalIndirectMileage,
      yearlyMileage:
        volunteerStatistics?.yearlyDirectMileage +
        volunteerStatistics?.yearlyIndirectMileage,
      lastActivityDate: volunteerStatistics?.lastActivityTimestamp
        ? getDateString(volunteerStatistics?.lastActivityTimestamp)
        : "--",
    };
  }, [volunteerStatistics]);

  useEffect(() => {
    const getVolunteerStatistics = async () => {
      setLoading(true);
      const endpoint = "niramayafoundation/api/v1/workforcesummary";
      const params = {
        workforceIdentifier: workforceIdentifier,
        timestamp: Date.now(),
        timezone: getCurrentTimeZone(),
        year: selectedYear,
      };
      const response = await apiService.get(endpoint, params);
      setVolunteerStatistics(response || {});
      setLoading(false);
    };

    getVolunteerStatistics();
  }, [selectedYear, workforceIdentifier]);

  return (
    <>
      <Col xs={24} xl={12}>
        <SectionCard
          title="Volunteer Activity Report"
          className="volunteer-statistics-card"
        >
          {loading ? (
            <Spin size="medium" className="spinnerCenter" />
          ) : (
            <VolunteerStatistics
              workforceIdentifier={workforceIdentifier}
              fields={statisticsFields}
              statistics={statistics}
            />
          )}
        </SectionCard>
      </Col>
      <Col xs={24} xl={12}>
        <SectionCard
          title="Mileage Report"
          className="volunteer-statistics-card"
        >
          {loading ? (
            <Spin size="medium" className="spinnerCenter" />
          ) : (
            <VolunteerStatistics
              workforceIdentifier={workforceIdentifier}
              fields={mileageFields}
              statistics={statistics}
              selectedYear={selectedYear}
              setSelectedYear={setSelectedYear}
              joiningDate={volunteerStatistics?.joiningDate}
            />
          )}
        </SectionCard>
      </Col>
    </>
  );
};

export default VolunteerStatisticsWrapper;
